import { Injector, Component, ViewEncapsulation, Inject } from '@angular/core';

import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';

import { DOCUMENT } from '@angular/common';

@Component({
  templateUrl: './theme11-brand.component.html',
  selector: 'theme11-brand',
  encapsulation: ViewEncapsulation.None,
})
export class Theme11BrandComponent extends AppComponentBase {
  defaultLogo =
    AppConsts.appBaseUrl + '/assets/common/images/app-logo-on-light.svg';
  remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

  constructor(
    injector: Injector,
    @Inject(DOCUMENT) private document: Document
  ) {
    super(injector);
  }

  clickTopbarToggle(): void {
    this.document.body.classList.toggle('m-topbar--on');
  }
}
